import * as actionTypes from './actionTypes';
import axios from 'axios';
//import SimpleCrypto from "simple-crypto-js";

export const setArbiAgreementSuccess = (response) => {
    return({
        type: actionTypes.ARBI_AGREEMENT_SUCCESS
    });
}

export const setGetAllArbiAgreementSuccess = (response) => {
    return({
        type: actionTypes.ARBI_GETALLAGREEMENT_SUCCESS,
        agreements: response
    });
}

export const setGetAllArbiAgreementFail = () => {
    return({
        type: actionTypes.ARBI_GETALLAGREEMENT_FAIL,
    });
}
export const setGetAllArbiAgreementLoading = () => {
    return({
        type: actionTypes.ARBI_GETALLAGREEMENT_LOADING,
    });
}
export const setGetAllArbiAgreementNotLoading = () => {
    return({
        type: actionTypes.ARBI_GETALLAGREEMENT_NOTLOADING,
    });
}

export const setArbiAgreementError = (error) => {
    return({
        type: actionTypes.ARBI_AGREEMENT_FAIL
    });
}

export const saveArbiAgreement = (date, firstpartyname, secondpartyname, firstpartyemail, secondpartyemail, description, firstpartysig, secondpartysig, agreementNo, firstPartyContact,secondPartyContact) => {
    let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/saveArbiAgreement`;
    console.log('sending... to saveArbiAgreement')
    const setOffer = {
        date: date,
        firstpartyname: firstpartyname,
        secondpartyname: secondpartyname,
        firstpartyemail: firstpartyemail,
        secondpartyemail: secondpartyemail,
        firstpartysig: firstpartysig,
        secondpartysig: secondpartysig,
        description:description,
        agreementNo:agreementNo,
        firstPartyContact,
        secondPartyContact
    };

    //var simpleCrypto = new SimpleCrypto(`${process.env.ENCRYPT_KEY}`);

    console.log('saveArbiAgreement params: '+JSON.stringify(setOffer));

    return (dispatch) => {
        axios.post(url, {
            ...setOffer
        })
        .then((response) => {
            console.log(response)
            if(response.data === 'error' || response.data === 'failed'){
                dispatch(setArbiAgreementError());
            }

            if (response.data === 'done'){
                dispatch(setArbiAgreementSuccess());
            }

        })
    };

}

export const getAllArbiAgreement = () => {
    let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/getAllArbitrationAgreements`;
    console.log('sending... to getAllArbiAgreement')
    const setOffer = { };

    console.log('getAllArbiAgreement params: '+JSON.stringify(setOffer));

    return (dispatch) => {
        dispatch(setGetAllArbiAgreementLoading())
        axios.post(url, {
            ...setOffer
        })
        .then((response) => {
            console.log('response: '+JSON.stringify(response))
            console.log('response.data: '+JSON.stringify(response.data))
            console.log('status: '+response.data.status)
            console.log('data: '+JSON.stringify(response.data.data) )
            if(response.data.status === 'error' || response.data.status === 'failed'){
                dispatch(setGetAllArbiAgreementFail());
                dispatch(setGetAllArbiAgreementNotLoading())
            }

            if (response.data.status === 'done'){
                dispatch(setGetAllArbiAgreementSuccess(response.data.data));
                dispatch(setGetAllArbiAgreementNotLoading())
            }

        })
    };
}